import {
	Box,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow
} from '@mui/material'
import { observer } from 'mobx-react'
import { TableColumn } from './DTO'

type FormattedTableProps<T> = {
	columns?: TableColumn<T>[]
	entries: T[]
	maxHeight?: string
}

export const FormattedTable = observer(<T extends Record<string, unknown>>(props: FormattedTableProps<T>) => {
	const columns = props.columns ?? Object.keys(props.entries[0]).map((k) => ({ name: k }) as TableColumn<T>)
	return <Box component={Table} maxHeight={props.maxHeight} width="100%">
		<TableHead>
			<TableRow>
				{columns.map((column, i) =>
					column.renderHeadingDynamic ?
						column.renderHeadingDynamic()
						: column.renderHeading
						?? <TableCell key={i}>{column.label ?? column.name}</TableCell>
				)}
			</TableRow>
		</TableHead>
		<TableBody>
			{props.entries.map((entry, i) =>
				<TableRow key={i}>
					{columns.map((column, j) =>
						column.renderCell
							? column.renderCell(entry)
							: <TableCell key={j}>
								{column.renderContent
									? column.renderContent(entry)
									: column.name
										? entry[column.name] === true
											? "true"
											: entry[column.name] === false
												? "false"
												: entry[column.name] as string
										: ""
								}
							</TableCell>
					)}
				</TableRow>
			)}
		</TableBody>
	</Box>
}
)